export const VALIDATION_STATE_SUCCESS = 'Success';
//# sourceMappingURL=validation.js.map